import KeyboardArrowDownOutlined from '@mui/icons-material/KeyboardArrowDownOutlined';
import { selectClasses, SelectProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

declare module '@mui/material/Select' {
  interface SelectPropsSizeOverrides {
    xsmall: true;
    small: true;
    medium: true;
    large: true;
  }

  interface BaseSelectProps {
    size?: 'xsmall' | 'small' | 'medium' | 'large';
  }
}

export default function Select(theme: Theme) {
  const rootStyles = (ownerState: SelectProps) => {
    const xsmallSize = ownerState.size === 'xsmall';
    const smallSize = ownerState.size === 'small';
    const mediumSize = ownerState.size === 'medium';
    const largeSize = ownerState.size === 'large';

    const defaultStyle = {
      height: xsmallSize
        ? 24
        : smallSize
        ? 32
        : mediumSize
        ? 40
        : largeSize
        ? 48
        : 32,

      padding: theme.spacing(0, 1),
      cursor: 'pointer',
      borderRadius: 4,
      marginTop: 0,

      [`&.Mui-focused > .${selectClasses.iconOpen}`]: {
        color: theme.palette.primary[500],
      },

      '&:hover': {
        boxShadow: `0 0 0 1px ${theme.palette.grey[400]}`,
      },
      '&:before': {
        display: 'none',
      },
      '&:after': {
        display: 'none',
      },

      '.MuiInputBase-input': {
        textOverflow: 'ellipsis',
      },
      [`& > .${selectClasses.select}`]: {
        padding: theme.spacing(0, 2, 0, 0),
        ...theme.typography.body3,
        fontWeight: 600,
        borderRadius: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '100%!important',
      },
    };

    return { ...defaultStyle };
  };

  return {
    MuiSelect: {
      defaultProps: {
        size: 'small',
        IconComponent: KeyboardArrowDownOutlined,
        // fullWidth: true,
        MenuProps: {
          sx: {
            maxHeight: '290px',
            marginTop: theme.spacing(0.5),
            borderRadius: 4,
          },
          PaperProps: {
            sx: {
              padding: theme.spacing(0.5),
              overflowY: 'auto',
              '&::-webkit-scrollbar': {
                width: '4px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#888', // scroll handle
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: 'transparent', // hide track
              },

              // Firefox
              scrollbarWidth: 'thin',
              scrollbarColor: '#888 transparent', // thumb color, track color
            },
          },
        },
      },
      styleOverrides: {
        icon: {
          // position: 'relative',
          top: 'auto',
          right: '4px',
          fontSize: '20px',
          color: theme.palette.grey[700],
        },
        root: ({ ownerState }: { ownerState: SelectProps }) =>
          rootStyles(ownerState),
      },
    },

    MuiNativeSelect: {
      defaultProps: {
        IconComponent: KeyboardArrowDownOutlined,
      },
      styleOverrides: {},
    },
  };
}
